var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16364 16.8821C2.50909 16.8821 2 16.3751 2 15.7232V5.15891C2 4.50702 2.50909 4 3.16364 4H9.30909C10.8 4 12 5.19513 12 6.67998V17.3529C11.6727 17.0994 11.2364 16.9183 10.8 16.9183H3.16364V16.8821Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81824 18.2419C3.8219 19.2135 4.63452 20 5.63641 20H10.4125C10.9127 20 11.3182 19.6064 11.3182 19.1209C11.3182 18.6354 10.9127 18.2419 10.4125 18.2419H3.81824Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3636 20H20.1818C21.186 20 22 19.2099 22 18.2353V8.41173C22 7.43711 21.186 6.64703 20.1818 6.64703H13.3635C13.3636 6.65799 13.3636 6.66897 13.3636 6.67995V10.5656C13.4843 10.4608 13.6436 10.3971 13.8182 10.3971H19.2727C19.6493 10.3971 19.9545 10.6933 19.9545 11.0588C19.9545 11.4243 19.6493 11.7206 19.2727 11.7206H13.8182C13.6436 11.7206 13.4843 11.6569 13.3636 11.5521V15.095C13.4843 14.9902 13.6436 14.9265 13.8182 14.9265H16.5455C16.922 14.9265 17.2273 15.2228 17.2273 15.5882C17.2273 15.9537 16.922 16.25 16.5455 16.25H13.8182C13.6436 16.25 13.4843 16.1863 13.3636 16.0815V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAlt1);
export default __webpack_public_path__ + "static/media/check-alt-1.713b60617440090c733420229127d330.svg";
export { ForwardRef as ReactComponent };